module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui dimmer modals page transition",
    class: {
      'show visible active': _vm.show
    }
  }, [_c('div', {
    staticClass: "ui basic modal transition visible active",
    staticStyle: {
      "margin-top": "-140px",
      "display": "block !important"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.lang.say('CHECK_REMOVE_ALL')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "image content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.say('CHECK_REMOVE_ALL_DESC')))])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "two fluid ui inverted buttons"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button",
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n                    No\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui green basic ok inverted button",
    on: {
      "click": _vm.confirm
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n                    Yes\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('i', {
    staticClass: "trash icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0f849d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MaskForCheckToRemoveAllProducts.vue
// module id = 381
// module chunks = 0